
/**
 * 根据模板付费类型及用户会员状态
 * 转换模板的类型显示及使用限制
 */
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["TmpLevelType", "UserLevelType", "UserLevel"]),
  },
  methods: {
    discountVisible(item) {
      return this.transTempPayType(item) === 1 && item.priceOfPromotion;
    },
    /**
     * 登录后的显示状态：免费，已购买，针对会员的免费+价格；
     * item.payType：0免费  1付费  2付费(优惠价) 3付费(折扣) 4企业专属 5:来画币 6:付费-企业会员免费 PS.不过23一直没有用过
     * 返回值：0免费，1原价，2已购买，3会员免费,6 促销模板
     */
    transTempPayType(item) {
      let test = () => {

        switch (item.payType) {
          // 免费模板
          case 0:
            return 0;
          // 会员免费
          case 1:
            if (item.tt) { //付费模板但已购买=>已购买
              return 2;
            } else if (this.UserLevel == 0 && !this.TmpLevelType) { //this.TmpLevelType >= 0 为临时会员
              // 模板促销
              //if (item.isPromoted) return 6;
              // 体验会员或者普通用户
              return 1;
            } else if (this.UserLevel > 0 || this.TmpLevelType >= 0 ) {
              return 3;
            }
            break;
          // 企业会员免费
          case 6:
            if (item.tt) {
              //付费模板但已购买=>已购买
              return 2;
            } else if (this.TmpLevelType == 0 || this.UserLevelType == 0) {
              return 1;
            } else if (this.UserLevelType > 0 || this.TmpLevelType > 0) {
              return 3;
            }
            break;
          default:
            return 1;
        }
      }

      let ret = test();
      //console.log(item.title,item.payType, this.TmpLevelType, this.UserLevelType, this.UserLevel);
      //console.log(item.title, ret);

      return ret;

    },
  }
};



// WEBPACK FOOTER //
// ./src/components/mixins/trans-temp-type.js